import { useState } from "react";
import { api } from "../api";
import Swal from "sweetalert2";
import { buildErrorHtml, isPositiveInt } from "../utils/validation";

export default function RegisterAttemptModal({ followUpId, onClose, onSuccess }) {

  const [notes, setNotes] = useState("");
  const [success, setSuccess] = useState(false);

  async function handleSubmit() {
    try {
      const errors = [];

      if (!isPositiveInt(followUpId)) {
        errors.push("Acompanhamento inválido.");
      }

      if (errors.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Campos inválidos",
          html: buildErrorHtml(errors),
        });
        return;
      }

      await api.post("/followups/attempt", {
        followUpId,
        notes,
        success
      });

      Swal.fire("Sucesso", "Tentativa registrada.", "success");
      onSuccess();
      onClose();
    } catch {
      Swal.fire("Erro", "Erro ao registrar tentativa.", "error");
    }
  }

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">

        <h5>Registrar Tentativa</h5>

        <textarea
          className="form-control mb-3"
          placeholder="Observações..."
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />

        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            checked={success}
            onChange={() => setSuccess(!success)}
          />
          <label className="form-check-label">
            Contato realizado com sucesso
          </label>
        </div>

        <div className="d-flex justify-content-end gap-2">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={handleSubmit}>
            Salvar
          </button>
        </div>

      </div>
    </div>
  );
}
